// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"2fa7b454","498":"71d2491c","513":"b05a1448","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};